export default __webpack_public_path__ + "static/media/CAT MIXTO.966ac448.svg";